import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Cancelar", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "ant-col ant-col-xs-10 ant-col-xl-10" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "ant-col ant-col-xs-2 ant-col-xl-2" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "ant-col ant-col-xs-3 ant-col-xl-4" }
const _hoisted_13 = { class: "ant-col ant-col-xs-3 ant-col-xl-4" }
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-14 ant-col-xl-14" }
const _hoisted_16 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_17 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_20 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { key: 3 }
const _hoisted_26 = { key: 4 }
const _hoisted_27 = { key: 5 }
const _hoisted_28 = { key: 6 }
const _hoisted_29 = { key: 7 }
const _hoisted_30 = {
  key: 8,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 9 }
const _hoisted_33 = { class: "ant-row" }
const _hoisted_34 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_35 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_36 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_tipo_rastreabilidade = _resolveComponent("selecionar-tipo-rastreabilidade")!
  const _component_selecionar_tipo_lancamento_rastreabilidade = _resolveComponent("selecionar-tipo-lancamento-rastreabilidade")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_card = _resolveComponent("card")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    title: "Seleção de Estoque / Rastreabilidades",
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 1260,
    centered: "",
    "wrap-class-name": _ctx.storeSistema.state.layoutMobile?'scroll-modal ss-modal-estoque':'ss-modal-estoque'
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelar && _ctx.cancelar(...args)))
        }, _hoisted_2),
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmar && _ctx.confirmar(...args)))
        }, _hoisted_4)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando,
        paragraph: { rows: 15 }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_a_form_item, {
                    label: "Cód. Produto",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        value: _ctx.state.definicaoProduto.codigoInterno,
                        disabled: ""
                      }, null, 8, _hoisted_7)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_a_form_item, {
                    label: "Produto",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        value: _ctx.state.definicaoProduto.produto,
                        disabled: ""
                      }, null, 8, _hoisted_9)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_a_form_item, {
                    label: "Unidade",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        style: {"text-align":"center"},
                        value: _ctx.state.definicaoProduto.unidade,
                        disabled: ""
                      }, null, 8, _hoisted_11)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_a_form_item, {
                    label: "Tipo de Rastreabilidade",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_tipo_rastreabilidade, {
                        valor: _ctx.state.definicaoProduto.tipoRastreabilidade,
                        "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.definicaoProduto.tipoRastreabilidade) = $event)),
                        disabled: true
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_a_form_item, {
                    label: "Tipo de Lançamento",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_tipo_lancamento_rastreabilidade, {
                        valor: _ctx.props.tipoLancamento,
                        "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.props.tipoLancamento) = $event)),
                        disabled: true
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createVNode(_component_card, { titulo: "LANÇAMENTO" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_a_form_item, {
                        label: "Identificador",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.identificadorSelecionado) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.identificadorSelecionado]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_a_form_item, {
                        label: "Quantidade",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            "quantidade-casas-decimais": _ctx.state.definicaoProduto.casasDecimais,
                            valor: _ctx.state.qtdSelecionada,
                            "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.qtdSelecionada) = $event))
                          }, null, 8, ["quantidade-casas-decimais", "valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_a_form_item, {
                        label: " ",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            style: {"width":"100%"},
                            class: "ant-btn ant-btn-secondary",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.adicionar && _ctx.adicionar(...args)))
                          }, _toDisplayString(_ctx.state.edicao ? 'Editar' : 'Adicionar'), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_card, {
                titulo: "RASTREABILIDADES",
                class: "ss-padding-separacao-esquerda"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_a_form_item, {
                        label: "Filtrar",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.buscaRapida) = $event)),
                            onKeyup: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.filtrar && _ctx.filtrar(...args)))
                          }, null, 544), [
                            [_vModelText, _ctx.state.buscaRapida]
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createVNode(_component_a_table, {
                    columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                    "data-source": _ctx.state.rastreabilidades,
                    rowKey: "codigo",
                    pagination: false,
                    loading: _ctx.gradeBase.buscandoDados,
                    size: "small"
                  }, {
                    bodyCell: _withCtx(({ column, record, text, index }) => [
                      (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            (record.qtdSelecionada > 0)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.editar(index, true))
                                }, [
                                  _createVNode(_component_icone, { nome: "editar" })
                                ], 8, _hoisted_21))
                              : _createCommentVNode("", true),
                            (record.qtdSelecionada <= 0)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  onClick: ($event: any) => (_ctx.editar(index, false))
                                }, [
                                  _createVNode(_component_icone, { nome: "mais" })
                                ], 8, _hoisted_22))
                              : _createCommentVNode("", true)
                          ]))
                        : (column.key === 'Identificador' && record.qtdSelecionada === 0)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              onClick: ($event: any) => (_ctx.editar(index, false)),
                              style: {"color":"blue","cursor":"pointer"}
                            }, _toDisplayString(record.identificador), 9, _hoisted_23))
                          : (column.key === 'NumeroLote')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(record.numeroLote), 1))
                            : (column.key === 'DataValidade')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataValidade)), 1))
                              : (column.key === 'NumeroSerieArma')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(record.numeroSerieArma), 1))
                                : (column.key === 'NumeroSerieCano')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(record.numeroSerieCano), 1))
                                  : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, _ctx.state.definicaoProduto.casasDecimais, false, true)), 1))
                                    : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinuto(text)), 1))
                                      : (column.key === 'Rastreabilidade')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                            (_ctx.state.definicaoProduto.tipoRastreabilidade === _ctx.ETipoRastreabilidade.Nenhum)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createElementVNode("span", null, "Identificador: " + _toDisplayString(record.codigo), 1),
                                                  _createElementVNode("span", null, "Descrição: " + _toDisplayString(record.descricaoEstoque), 1),
                                                  _createElementVNode("span", null, "Qtd Disponível: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.quantidade, _ctx.state.definicaoProduto.casasDecimais, false, true)), 1),
                                                  _createElementVNode("span", null, "Qtd Selecionada: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.qtdSelecionada, _ctx.state.definicaoProduto.casasDecimais)), 1)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            (_ctx.state.definicaoProduto.tipoRastreabilidade === _ctx.ETipoRastreabilidade.Outros)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                  _createElementVNode("span", null, "Identificador: " + _toDisplayString(record.identificador), 1),
                                                  _createElementVNode("span", null, "Descrição: " + _toDisplayString(record.descricao), 1),
                                                  _createElementVNode("span", null, "Qtd Disponível: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.saldo, _ctx.state.definicaoProduto.casasDecimais)), 1),
                                                  _createElementVNode("span", null, "Qtd Selecionada: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.qtdSelecionada, _ctx.state.definicaoProduto.casasDecimais)), 1)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            (_ctx.state.definicaoProduto.tipoRastreabilidade === _ctx.ETipoRastreabilidade.Lote)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                  _createElementVNode("span", null, "Identificador: " + _toDisplayString(record.identificador), 1),
                                                  _createElementVNode("span", null, "Descrição: " + _toDisplayString(record.descricao), 1),
                                                  _createElementVNode("span", null, "Qtd Disponível: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.saldo, _ctx.state.definicaoProduto.casasDecimais)), 1),
                                                  _createElementVNode("span", null, "Qtd Selecionada: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.qtdSelecionada, _ctx.state.definicaoProduto.casasDecimais)), 1),
                                                  _createElementVNode("span", null, "Nº do Lote: " + _toDisplayString(record.numeroLote), 1),
                                                  _createElementVNode("span", null, "Vencimento: " + _toDisplayString(record.dataValidade), 1)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            (_ctx.state.definicaoProduto.tipoRastreabilidade === _ctx.ETipoRastreabilidade.Armamento)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                  _createElementVNode("span", null, "Identificador: " + _toDisplayString(record.identificador), 1),
                                                  _createElementVNode("span", null, "Descrição: " + _toDisplayString(record.descricao), 1),
                                                  _createElementVNode("span", null, "Qtd Disponível: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.saldo, _ctx.state.definicaoProduto.casasDecimais)), 1),
                                                  _createElementVNode("span", null, "Qtd Selecionada: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.qtdSelecionada, _ctx.state.definicaoProduto.casasDecimais)), 1),
                                                  _createElementVNode("span", null, "Nº da Arma: " + _toDisplayString(record.numeroSerieArma), 1),
                                                  _createElementVNode("span", null, "Nº do Cano: " + _toDisplayString(record.numeroSerieCano), 1)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("a", {
                                              onClick: ($event: any) => (_ctx.editar(index, false))
                                            }, [
                                              _createVNode(_component_icone, { nome: "editar" })
                                            ], 8, _hoisted_31)
                                          ]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(text), 1))
                    ]),
                    emptyText: _withCtx(() => [
                      _createVNode(_component_mensagem_sem_dados, {
                        resultadoPesquisa: true,
                        mensagem: "Nenhuma rastreabilidade lançada."
                      })
                    ]),
                    _: 1
                  }, 8, ["columns", "data-source", "loading"]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_a_form_item, {
                        label: "Qtd do Item",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            "quantidade-casas-decimais": _ctx.state.definicaoProduto.casasDecimais,
                            valor: _ctx.props.quantidade,
                            disabled: true
                          }, null, 8, ["quantidade-casas-decimais", "valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_a_form_item, {
                        label: "Qtd Selecionada",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            "quantidade-casas-decimais": _ctx.state.definicaoProduto.casasDecimais,
                            valor: _ctx.state.qtdTotalSelecionada,
                            disabled: true
                          }, null, 8, ["quantidade-casas-decimais", "valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_a_form_item, {
                        label: "Qtd Faltando",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            "quantidade-casas-decimais": _ctx.state.definicaoProduto.casasDecimais,
                            valor: _ctx.props.quantidade - _ctx.state.qtdTotalSelecionada,
                            permitirValorNegativo: true,
                            disabled: true
                          }, null, 8, ["quantidade-casas-decimais", "valor"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}